module.exports = __webpack_public_path__ + "static/media/network.20837254.svg";